module.exports = __webpack_public_path__ + "static/media/antdesign.9a695eb1.png";